<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label"/>
                <div class="kt-portlet__head-toolbar">
                    <app-button type="secondary" @handleClick="back" class="size ">
                        <i class="glyphicons glyphicons-arrow-left"></i> {{ $t('AppOperatorsEditCreate.Voltar') }}
                    </app-button>
                </div>
            </div>
            <div class="kt-form shadow-lg pl-3 pr-3 bg-white mt-3 mt-md-5">
                <AppOperatorsForm :creating="creating" :edit="edit" @handleCreate="handleCreate"
                                  @handleUpdate="handleUpdate" @handleRemove="handleRemove"/>
            </div>
        </div>
    </div>
</template>
<script>
import {router} from "@/router";

import AppButton from '../../common/AppButton'
import AppOperatorsForm from "./AppOperatorsForm";

import OperatorsService from "../../../services/OperatorsService";
import BeaconsService from "../../../services/BeaconsService";

export default {
    mounted() {
        this.operatorId = this.$route.params.id;

        this.operatorService = new OperatorsService();
        this.beaconsService = new BeaconsService();

        this.edit = {}
        this.creating = this.$route.params.creating

        if (!this.creating) {
            this.getDetails();
        }
    },
    data() {
        return {
            creating: null,
            edit: null,
            operatorService: null,
            beaconsService: null,
            operatorId: null
        }
    },
    methods: {
        back() {
            router.go(-1);
        },
        handleRemove(operatorId) {
            this.operatorService.removeOperator(operatorId)
                .then(() => {
                    this.toastSuccess(this.$t('AppOperatorsEditCreate.Operador removido com sucesso'));
                    this.back();
                })
                .catch((error) => {
                    this.toastError(error, this.$t('AppOperatorsEditCreate.Não foi possivel completar a operação'));
                })
        },
        handleUpdate(data, originalBeaconId, operatorId) {
            // Verifica se é necessário deletar algum link já existente antes de criar outro
            if (!(!originalBeaconId || originalBeaconId === data.beacon_id)) {
                this.beaconsService.deleteBeaconLink(data.link_id).then(() => {
                    this.handleLinkCreation(data, originalBeaconId, operatorId);
                })
            } else {
                this.handleLinkCreation(data, originalBeaconId, operatorId);
            }

            this.operatorService.updateV3(this.operatorId, data)
                .then(() => {
                    this.toastSuccess(this.$t('AppOperatorsEditCreate.Atualização realizada com sucesso'));
                    this.back();
                })
                .catch((error) => {
                    this.toastError(error, this.$t('AppOperatorsEditCreate.Não foi possivel completar a operação'));
                });
        },
        handleCreate(data) {
            this.operatorService.createV3(this.operatorId, data)
                .then((response) => {
                    this.toastSuccess(this.$t('AppOperatorsEditCreate.Cadastro realizado com sucesso'));
                    this.handleLinkCreation(data, null, response);
                    this.back();
                })
                .catch((error) => {
                    this.toastError(error, this.$t('AppOperatorsEditCreate.Não foi possivel completar a operação'));
                });
        },
        handleLinkCreation(data, originalBeaconId, operatorId) {
            if (data.beacon_id && (originalBeaconId == null || originalBeaconId !== data.beacon_id)) {
                this.beaconsService.createBeaconLink({
                    operator_id: operatorId,
                    beacon_id: data.beacon_id
                })
            }
        },
        getDetails() {
            this.operatorService.getDetailsEditV3(this.operatorId)
                .then((response) => {
                    this.edit = response;
                })
                .catch((error) => {
                    this.toastError(error, this.$t('AppOperatorsEditCreate.Não foi possivel completar a operação'))
                    router.push({name: 'operators'})
                });
        },
        toastSuccess(summary, life = 5000) {
            this.$toast.add({
                severity: 'success',
                summary: summary,
                life: life
            });
        },
        toastError(error, summary, life = 5000) {
            if (error.response && error.response.data && error.response.data.details) {
                this.$toast.add({
                    severity: 'error',
                    summary: error.response.data.details,
                    life: life
                });
                return;
            }

            this.$toast.add({
                severity: 'error',
                summary: summary,
                life: life
            });
        }
    },
    components: {
        AppButton, AppOperatorsForm
    }
}
</script>

<style scoped>
.kt-form {
    width: 35%;
    margin: 0 auto;
}

@media (max-width: 758px) {
    .kt-form {
        width: 95%;
    }
}

@media (max-width: 1024px) and (min-width: 758px) {
    .kt-form {
        width: 70%;
    }
}
</style>
